import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { AuthVerifyMfaOtp } from "@/components/features/auth/verify-mfa-otp";

export const AuthVerifyMfaOtpPage = () => {
	return (
		<PageMeta title="認証コード入力" url={generatePath(PATHS.AUTH.VERIFY_MFA_OTP)}>
			<AuthVerifyMfaOtp />
		</PageMeta>
	);
};
